<template>
    <div id="user-list" class="container-fluid main-content page-content">
        <div class="page-header">
            <div>
                <h3 class="page-title">{{ $t('users') }}</h3>
            </div>
            <div class="d-flex align-items-center">
                <p class="text-primary m-0 mr-3 align-self-center text-btn" @click="exportUser()">
                    <font-awesome-icon class="mr-3 text-primary" :icon="['fas', 'upload']"/>
                    {{ $t('export') }}
                </p>
                <p class="text-primary m-0 mr-3 align-self-center text-btn" v-b-modal.import-user>
                    <font-awesome-icon class="mr-3 text-primary" :icon="['fas', 'download']"/>
                    {{ $t('import') }}
                </p>
                <button type="button" class="btn btn-primary rounded-pill" v-b-modal.invite-user>{{ $t('invite-user') }}</button>
            </div>
            <import-user></import-user>
        </div>
        <preloader-placeholder :loading="loading" :resultlength="(users ? users.length : 0)" :type="'user'"></preloader-placeholder>
        <div class="box-wrap" v-if="loading !== true">
            <user-box
                v-for="user in users"
                :key="user.id"
                v-bind:user="user">
            </user-box>
        </div>
    </div>
</template>
<script>

// Components
import PreloaderPlaceholder from '../../PreloaderPlaceholder.vue';
import UserBox              from './UserBox.vue';
import ImportUser           from './ImportUser.vue';
import { EventBus }         from '@/helpers/EventBus.js';
import { escapeHtml }       from '@/plugins/dialog';
import moment from 'moment';

// Import external libraries
import {
    mapState,
    mapActions,
    mapGetters
} from 'vuex';

// Internal services js
import Alert        from '@/helpers/Alert.js';

export default {
    components: {
        UserBox,
        PreloaderPlaceholder,
        ImportUser
    },

    data () {
        return {
            newUser: {
                'email':      '',
                'last-name':  '',
                'first-name': '',
                'language':   'fr',
                'is-enabled': true,
                'is-admin':   false
            },
            submitted: false,
            loading:   false
        };
    },

    computed: {
        ...mapGetters('core/users', [
            'users'
        ]),
        ...mapState('core/auth', [
            'user'
        ])
    },
    created () {
        // Check if this user is an admin
        if (!this.user.attributes['is-admin'] && !this.user.attributes['is-super-admin']) {
            this.$router.push({ name: `facebook-messages:${this.$i18n.locale}` });
        }
    },

    mounted () {
        // Show preloader
        this.loading = true;

        // Get a list of users
        this.getUsers()
            .then(() => {
                // Hide preloader
                this.loading = false;
            });

        // Update the user list after importing users
        EventBus.$off('user-imported');
        EventBus.$on('user-imported', () => {
            this.loading = true;
            this.getUsers()
                .then(() => {
                    // Hide preloader
                    this.loading = false;
                });
        });
    },

    methods: {
        /**
         * Define moment to use it in template
         */
        moment,

        /**
         * Methods for users API request
         *
         * getUsers     get list of users for this tenant
         * export       export list of users in excel sheet
         */
        ...mapActions('core/users', {
            'getUsers': 'index',
            'export':   'export'
        }),

        /**
         * Call Export Users.
         */
        exportUser () {
            const email = escapeHtml(this.user.attributes.email);

            this.$dialog.confirm({
                title:       this.$t('confirmation-required'),
                html:        this.$t('confirmation-export-contacts', { email }),
                confirmText: this.$t('export')
            })
                .then((confirmed) => {
                    if (confirmed) {
                        this.export()
                            .then(() => {
                                Alert.success(`${this.$i18n.t('file-send')} ${this.user.attributes.email}.`);
                            })
                            .catch(() => {
                                Alert.fail(this.$i18n.t('mail-faild'));
                            });
                    }
                });
        }
    }
};
</script>
